import React from 'react';
import SiteCharts from '../../../components/SiteCharts/SiteCharts';
import { sgNbAdditionNrChartConfig } from '../chartConfigs';

/**
 * Props for the SgNbAdditionNrEcharts component
 */
interface SgNbAdditionNrEchartsProps {
  /** Callback function to toggle fullscreen mode */
  onFullscreenToggle: () => void;
  /** Current fullscreen state */
  isFullscreen: boolean;
}

/**
 * SgNB Addition Success Rate Chart (NR Site Level)
 * 
 * Displays Secondary gNodeB (SgNB) addition metrics for EN-DC in NR sites:
 * - SgNB Addition Success (count)
 * - SgNB Addition Attempt (count)
 * - SgNB Addition Success Rate (percentage)
 * 
 * @component
 * @example
 * ```tsx
 * <SgNbAdditionNrEcharts onFullscreenToggle={handleFullscreen} isFullscreen={false} />
 * ```
 * 
 * @see {@link ../chartConfigs.ts} - Chart configuration (sgNbAdditionNrChartConfig)
 * @see {@link ../../../components/SiteCharts/SiteCharts.tsx} - Template component
 * @see API: /api/nr/sgnb-addition?site_name={siteName}
 */
const SgNbAdditionNrEcharts: React.FC<SgNbAdditionNrEchartsProps> = ({ 
  onFullscreenToggle, 
  isFullscreen 
}) => {
  return (
    <SiteCharts 
      config={sgNbAdditionNrChartConfig}
      onFullscreenToggle={onFullscreenToggle}
      isFullscreen={isFullscreen}
    />
  );
};

export default SgNbAdditionNrEcharts;
